import { Field, useFormikContext } from "formik";
import { useRef, useState, forwardRef, ForwardedRef, ReactNode } from "react";
import useAutosizeTextArea from "../../hooks/useAutosizeTextArea";

interface TextareaProps {
  name: string;
  maxLength?: number;
  currentText: string;
  label: ReactNode;
}

const Textarea = forwardRef(
  (
    { name, maxLength = 500, currentText, label }: TextareaProps,
    ref: ForwardedRef<HTMLTextAreaElement>
  ) => {
    const { setFieldValue, values, errors, touched } = useFormikContext<any>();
    const [charCount, setCharCount] = useState(currentText?.length ?? 0);
    const [text, setText] = useState(currentText ?? "");
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      const value = event.target.value;
      const val = event.target?.value;

      if (value.length <= maxLength) {
        setFieldValue(name, value);
        setText(val);
        setCharCount(value.length);
      }
    };

    useAutosizeTextArea(textAreaRef.current, text);

    return (
      <>
      <div className="md:flex justify-between items-end textarea-label-wrapper mb-2">

        <label htmlFor={name} className="textarea-label">
          <span>
            {label}
            {touched[name] && errors[name] && (
              <span className="validation-error">
                <>{errors[name]}</>
              </span>
            )}
          </span>
        </label>
        <div className="md:text-right remaining-chars">
          {charCount}/{maxLength} tecken
        </div>
      </div>

        <Field
          className={`w-full ${errors[name] && touched[name] ? "has-error" : ""
            } `}
          name={name}
          id={name}
          as="textarea"
          value={values[name]}
          onChange={handleChange}
          innerRef={textAreaRef}
        />
      </>
    );
  }
);

export default Textarea;
